
import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';

@Component
export default class RealNameAuth extends Vue{
    @Prop() redirectUrl;
    sEncData = '';

    created(): void {
        if(!this.redirectUrl) {
            return;
        }
        axios.get('/member/real-name/enc-data?redirectUrl=' + this.redirectUrl)
        .then(r=>{
            this.sEncData = r.data;
            (this.$refs.sEncData as HTMLInputElement).value = this.sEncData;
            (this.$refs.authForm as HTMLFormElement).submit();
        });
    }
}
